/*
 * the "..." expand operator does not work on element.validity
 * so this function will copy the validity state into a new object
 */
export function copyValidityState(validityState: ValidityState): ValidityState {
  return {
    badInput: validityState.badInput,
    customError: validityState.customError,
    patternMismatch: validityState.patternMismatch,
    rangeOverflow: validityState.rangeOverflow,
    rangeUnderflow: validityState.rangeUnderflow,
    stepMismatch: validityState.stepMismatch,
    tooLong: validityState.tooLong,
    tooShort: validityState.tooShort,
    typeMismatch: validityState.typeMismatch,
    valid: validityState.valid,
    valueMissing: validityState.valueMissing,
  }
}
